import { ReactNode, useRef } from 'react';
import { createPortal } from 'react-dom';

const getOverlayRoot = (id: string) => {
  let root = document.getElementById(id);
  if (!root) {
    root = document.createElement('div');
    root.setAttribute('id', id);
    document.body.appendChild(root);
  }
  return root;
};

export function OverlayPortal({
  children,
}: {
  hostName?: string;
  children: ReactNode;
}) {
  const rootElem = useRef<HTMLElement>(getOverlayRoot('overlay-root'));

  return rootElem.current ? createPortal(children, rootElem.current) : null;
}
